export const shrink = (text, maxChars) => {
  if (!text || text.length <= maxChars) return text;
  const lastPartLength = Math.round(maxChars / 4);
  let lastPart = text.slice(maxChars - lastPartLength, maxChars);
  const m = lastPart.match(/\s+\S*$/);
  if (m) lastPart = lastPart.slice(0, lastPart.length - m[0].length + 1);
  lastPart = `${lastPart.slice(0, -1)}…`;
  return text.slice(0, maxChars - lastPartLength) + lastPart;
};
